export const departmentAgentFlows = {
  "marketing": [
    "Campanha",
    "Lead"
  ],
  "commercial": [
    "Oportunidade",
    "Pré-venda",
    "Orçamento de Venda"
  ],
  "sales": [
    "Ordem de Venda",
    "Ordem de Serviço",
    "Fatura de Venda"
  ],
  "production": [
    "Ordem de Produção",
    "Produto acabado",
    "Estoque"
  ],
  "purchasing": [
    "Solicitação de Cotação",
    "Cotação",
    "Ordem de Compra",
    "Fatura de Compra"
  ],
  "inventory": [
    "Estoque",
    "Picking",
    "Packing",
    "Remessa"
  ],
  "logistics": [
    "Remessa",
    "Romaneio",
    "CT-e",
    "MDF-e"
  ],
  "tax": [
    "Fatura de Venda",
    "NFS-e ou NF-e",
    "CT-e",
    "MDF-e"
  ],
  "finance": [
    "Fatura de Venda",
    "Contas a Receber",
    "Fatura de Compra",
    "Contas a Pagar",
    "Fluxo de Caixa"
  ],
  "accounting": [
    "NFS-e ou NF-e",
    "Fatura de Compra",
    "Fechamento contábil"
  ],
  "it": [
    "Integrações e acessos"
  ],
  "hr": [
    "Pessoas e capacitação"
  ]
};
export const departmentAgentStacks = {
  "marketing": {
    "pt": [
      [
        "Consulta ao CRM",
        "Busca em conhecimento",
        "Criação de tarefas"
      ],
      [
        "Qualificação de interesse",
        "Síntese de histórico",
        "Encaminhamento comercial"
      ],
      [
        "CRM (HubSpot ou Salesforce)",
        "Formulários e campanhas",
        "Zild Flow"
      ]
    ],
    "en": [
      [
        "CRM lookup",
        "Knowledge search",
        "Task creation"
      ],
      [
        "Interest qualification",
        "History summarization",
        "Commercial handoff"
      ],
      [
        "CRM (HubSpot or Salesforce)",
        "Forms and campaigns",
        "Zild Flow"
      ]
    ]
  },
  "commercial": {
    "pt": [
      [
        "Consulta ao CRM",
        "Busca em documentos",
        "Registro de follow-up"
      ],
      [
        "Levantamento de requisitos",
        "Pesquisa com fontes",
        "Preparação de abordagem"
      ],
      [
        "CRM (HubSpot ou Salesforce)",
        "SharePoint",
        "Zild Flow"
      ]
    ],
    "en": [
      [
        "CRM lookup",
        "Document search",
        "Follow-up records"
      ],
      [
        "Requirements gathering",
        "Source-based research",
        "Outreach preparation"
      ],
      [
        "CRM (HubSpot or Salesforce)",
        "SharePoint",
        "Zild Flow"
      ]
    ]
  },
  "sales": {
    "pt": [
      [
        "Consulta de catálogo e preços",
        "Consulta de estoque",
        "Preparação de registros no ERP"
      ],
      [
        "Conferência de condições comerciais",
        "Preparação de propostas",
        "Coordenação entre áreas"
      ],
      [
        "ERP (Omie, SAP Business One ou WinThor)",
        "CRM",
        "Zild Flow"
      ]
    ],
    "en": [
      [
        "Catalog and price lookup",
        "Inventory lookup",
        "ERP record preparation"
      ],
      [
        "Commercial terms checking",
        "Proposal preparation",
        "Cross-team coordination"
      ],
      [
        "ERP (Omie, SAP Business One or WinThor)",
        "CRM",
        "Zild Flow"
      ]
    ]
  },
  "production": {
    "pt": [
      [
        "Consulta de ordens e materiais",
        "Busca de procedimentos",
        "Abertura de tarefas"
      ],
      [
        "Análise de faltas de materiais",
        "Acompanhamento de prazos",
        "Tratamento de não conformidades"
      ],
      [
        "ERP / MRP da empresa",
        "MES por API, quando disponível",
        "SharePoint"
      ]
    ],
    "en": [
      [
        "Order and material lookup",
        "Procedure search",
        "Task creation"
      ],
      [
        "Material shortage analysis",
        "Deadline tracking",
        "Nonconformity handling"
      ],
      [
        "Company ERP / MRP",
        "MES API, where available",
        "SharePoint"
      ]
    ]
  },
  "purchasing": {
    "pt": [
      [
        "Leitura de propostas",
        "Consulta de fornecedores e pedidos",
        "Preparação de solicitações"
      ],
      [
        "Comparação de cotações",
        "Conferência de condições",
        "Acompanhamento de fornecedores"
      ],
      [
        "ERP (Omie ou SAP Business One)",
        "E-mail corporativo",
        "Zild Flow"
      ]
    ],
    "en": [
      [
        "Proposal reading",
        "Supplier and order lookup",
        "Request preparation"
      ],
      [
        "Quotation comparison",
        "Terms checking",
        "Supplier follow-up"
      ],
      [
        "ERP (Omie or SAP Business One)",
        "Corporate email",
        "Zild Flow"
      ]
    ]
  },
  "inventory": {
    "pt": [
      [
        "Consulta de saldos e reservas",
        "Leitura de documentos",
        "Registro de divergências"
      ],
      [
        "Conferência de itens",
        "Tratamento de faltas",
        "Coordenação de reposição"
      ],
      [
        "WMS por API, quando disponível",
        "ERP da empresa",
        "Zild Flow"
      ]
    ],
    "en": [
      [
        "Stock and reservation lookup",
        "Document reading",
        "Discrepancy records"
      ],
      [
        "Item checking",
        "Shortage handling",
        "Replenishment coordination"
      ],
      [
        "WMS API, where available",
        "Company ERP",
        "Zild Flow"
      ]
    ]
  },
  "logistics": {
    "pt": [
      [
        "Consulta de eventos de transporte",
        "Extração de dados documentais",
        "Abertura de ocorrências"
      ],
      [
        "Conferência de volumes",
        "Tratamento de exceções",
        "Coordenação de entregas"
      ],
      [
        "TMS da empresa / ESL",
        "WMS por API, quando disponível",
        "Zild Flow"
      ]
    ],
    "en": [
      [
        "Transport event lookup",
        "Document data extraction",
        "Incident creation"
      ],
      [
        "Package checking",
        "Exception handling",
        "Delivery coordination"
      ],
      [
        "Company TMS / ESL",
        "WMS API, where available",
        "Zild Flow"
      ]
    ]
  },
  "tax": {
    "pt": [
      [
        "Extração de dados de documentos",
        "Consulta de cadastro e pedidos",
        "Consulta de status fiscal"
      ],
      [
        "Conferência de campos",
        "Identificação de divergências",
        "Encaminhamento para revisão fiscal"
      ],
      [
        "Sistema fiscal por API, quando disponível",
        "ERP da empresa",
        "Repositório de documentos"
      ]
    ],
    "en": [
      [
        "Document data extraction",
        "Master record and order lookup",
        "Tax status lookup"
      ],
      [
        "Field checking",
        "Discrepancy detection",
        "Tax review handoff"
      ],
      [
        "Tax system API, where available",
        "Company ERP",
        "Document repository"
      ]
    ]
  },
  "finance": {
    "pt": [
      [
        "Consulta de títulos e vencimentos",
        "Importação de extratos autorizados",
        "Preparação de relatórios"
      ],
      [
        "Conciliação assistida",
        "Projeção com premissas explícitas",
        "Tratamento de pendências financeiras"
      ],
      [
        "ERP (Omie ou SAP Business One)",
        "Fonte bancária autorizada",
        "Zild Flow"
      ]
    ],
    "en": [
      [
        "Invoice and due-date lookup",
        "Authorized statement import",
        "Report preparation"
      ],
      [
        "Assisted reconciliation",
        "Forecasting with explicit assumptions",
        "Financial exception handling"
      ],
      [
        "ERP (Omie or SAP Business One)",
        "Authorized banking source",
        "Zild Flow"
      ]
    ]
  },
  "accounting": {
    "pt": [
      [
        "Consulta de movimentos",
        "Busca de comprovantes",
        "Checklist de fechamento"
      ],
      [
        "Conciliação entre fontes",
        "Organização de evidências",
        "Acompanhamento de pendências"
      ],
      [
        "Sistema contábil por API, quando disponível",
        "ERP da empresa",
        "SharePoint"
      ]
    ],
    "en": [
      [
        "Movement lookup",
        "Evidence search",
        "Close checklist"
      ],
      [
        "Cross-source reconciliation",
        "Evidence organization",
        "Exception tracking"
      ],
      [
        "Accounting system API, where available",
        "Company ERP",
        "SharePoint"
      ]
    ]
  },
  "it": {
    "pt": [
      [
        "Consulta de logs autorizados",
        "Busca na base técnica",
        "Abertura de chamados"
      ],
      [
        "Triagem de incidentes",
        "Diagnóstico assistido",
        "Escalonamento técnico"
      ],
      [
        "APIs e webhooks dos sistemas",
        "Plataforma de chamados",
        "Microsoft Teams"
      ]
    ],
    "en": [
      [
        "Authorized log lookup",
        "Technical knowledge search",
        "Ticket creation"
      ],
      [
        "Incident triage",
        "Assisted diagnostics",
        "Technical escalation"
      ],
      [
        "System APIs and webhooks",
        "Ticket platform",
        "Microsoft Teams"
      ]
    ]
  },
  "hr": {
    "pt": [
      [
        "Busca em políticas aprovadas",
        "Criação de tarefas de onboarding",
        "Consulta de trilhas de capacitação"
      ],
      [
        "Orientação com fontes",
        "Coordenação de onboarding",
        "Encaminhamento de solicitações"
      ],
      [
        "Sistema de RH por API, quando disponível",
        "SharePoint",
        "Microsoft Teams"
      ]
    ],
    "en": [
      [
        "Approved policy search",
        "Onboarding task creation",
        "Training path lookup"
      ],
      [
        "Source-based guidance",
        "Onboarding coordination",
        "Request routing"
      ],
      [
        "HR system API, where available",
        "SharePoint",
        "Microsoft Teams"
      ]
    ]
  }
};
